export const dateFormat = (dateStr) => {
  if (!dateStr) return "";
  const dArr = dateStr.split("-");
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return (
    `${dArr[2]  } ${  months[parseInt(dArr[1]) - 1]  } ${  dArr[0].substring(2)}`
  );
};

export function isEnquiry(check) {
  if (typeof check === "object" && check !== null && ["enquire", "received"].includes(check?.result)) {
    return true;
  }

  return false;
}

export function getParams(url = "") {
  const params = {};

  const [, search] = url.split("?", 2);

  if (search) {
    const paramStrings = search.split('&');

    for (let i = 0; i < paramStrings.length; i += 1) {
      const [key, value] = paramStrings[i].split('=', 2);
      params[key] = decodeURIComponent(value);
    }
  }

  return params;
}

export const weekdays = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

export function sortByLabel(a, b) {
  return a.label.localeCompare(b.label);
}

export function sortBySortOrder(a, b) {
  return a.sortOrder - b.sortOrder;
}

export function titleCase(string){
  return string[0].toUpperCase() + string.slice(1).toLowerCase();
}

export const rIC =
  "requestIdleCallback" in window ? requestIdleCallback : setTimeout;

// Tracking

/**
 * Sends data to GA tracker(s)
 * @param { { hitType: "pageview"; page: string; title: string } | { hitType: 'event'; eventAction: string; eventLabel?: string } } payload
 */
export function sendAnalytics(payload = {}) {
  const data = { ...payload };
  // Modify payload
  if (data.hitType === "pageview") data.page = `/DMN/${data.page}`;
  if (data.hitType === "event") data.eventCategory = "Booking";

  if (typeof ga === "function" && typeof window.gaKey !== "undefined") {
    window.gaKey.forEach((key) => ga(`${key}.send`, data));
  }
}

export function createAnalyticsTag() {
  if (typeof ga === "undefined") {
    window.gaKey = window.gaKey || [];

    (function(i, s, o, g, r, a, m) {
      i.GoogleAnalyticsObject = r;
      i[r] = i[r] || function() {
        (i[r].q = i[r].q || []).push(arguments)
      }, i[r].l = 1 * new Date();
      a = s.createElement(o),
        m = s.getElementsByTagName(o)[0];
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m)
    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
  }

  window.gaKey.push("DMN");
  ga("create", "UA-210225503-1", "auto", "DMN");
}

export function getManadatoryPackagesFromAPI(item) {
  const updatedItem = {
    packageMandatorySunday: typeof item.packageMandatorySunday === "boolean" ? item.packageMandatorySunday : item.parent.packageMandatorySunday,
    packageMandatoryMonday: typeof item.packageMandatoryMonday === "boolean" ? item.packageMandatoryMonday : item.parent.packageMandatoryMonday,
    packageMandatoryTuesday: typeof item.packageMandatoryTuesday === "boolean" ? item.packageMandatoryTuesday : item.parent.packageMandatoryTuesday,
    packageMandatoryWednesday: typeof item.packageMandatoryWednesday === "boolean" ? item.packageMandatoryWednesday : item.parent.packageMandatoryWednesday,
    packageMandatoryThursday: typeof item.packageMandatoryThursday === "boolean" ? item.packageMandatoryThursday : item.parent.packageMandatoryThursday,
    packageMandatoryFriday: typeof item.packageMandatoryFriday === "boolean" ? item.packageMandatoryFriday : item.parent.packageMandatoryFriday,
    packageMandatorySaturday: typeof item.packageMandatorySaturday === "boolean" ? item.packageMandatorySaturday : item.parent.packageMandatorySaturday,
  }

  return weekdays.reduce((previousWeekdays, weekday) => ([...previousWeekdays, updatedItem[`packageMandatory${titleCase(weekday)}`] ? { label: titleCase(weekday), value: weekday } : false]), []).filter(Boolean);
}

export function getManadatoryPackagesForAPI(selectedWeekdayOptions) {
  const selectedWeekdays = selectedWeekdayOptions.map((option) => option.value);
  return weekdays.reduce((previousWeekdays, weekday) => ({...previousWeekdays, [`packageMandatory${titleCase(weekday)}`]: selectedWeekdays.includes(weekday)}), {});
}
